import { useState } from "react";

import useXRayPromptBlueprint from "@/queries/playground/useXRayBlueprint";
import { PromptBlueprint, PromptVersion } from "@/types";

export const useXrayMode = (promptVersion: PromptVersion | undefined) => {
  const [isXrayMode, setIsXrayMode] = useState(false);

  const { data, isLoading } = useXRayPromptBlueprint(
    promptVersion as PromptBlueprint,
    !!promptVersion,
  );

  const XrayBlueprint = data?.prompt_blueprint;
  const isXrayLoading = isXrayMode && !!promptVersion && isLoading;

  return {
    isXrayMode,
    XrayBlueprint,
    setIsXrayMode,
    isXrayAvailable: data?.expanded,
    isXrayLoading,
  };
};
